import { render, staticRenderFns } from "./view-files-prescriptions.vue?vue&type=template&id=1e6bc08e"
import script from "./view-files-prescriptions.vue?vue&type=script&lang=js"
export * from "./view-files-prescriptions.vue?vue&type=script&lang=js"
import style0 from "./view-files-prescriptions.vue?vue&type=style&index=0&id=1e6bc08e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports